// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Users_avatar__3a8ya","usersList":"Users_usersList__URAnd","userItem":"Users_userItem__EXVmT"};